import {Children, Fragment, ReactElement, ReactNode} from 'react';
import EmptyContentCardListV4 from './EmptyContentCardListV4';
import useScreenType from '../hook/useScreenType';

interface IProps {
  children: ReactElement[];
  className?: string;
  isBig?: boolean;
  // isBig 일 때 큰 화면 반응형이 필요한 경우 사용. 이벤트 페이지 시안에 따라 필요 없어질 수도 있음.
  isBigResponsive?: boolean;
  adLineNumber?: number; // 광고 노출 라인 (ex)5: 다섯줄 마다 광고 노출
  getAdElement?: (index: number) => ReactNode;
  showEmptyContentCard?: boolean;
}

export default function ContentCardWrapperV4({
  children,
  className,
  isBig,
  isBigResponsive,
  adLineNumber = 0,
  getAdElement,
  showEmptyContentCard,
}: IProps) {
  const {isMedium, isLarge} = useScreenType();
  const divisionCount = isBig
    ? isBigResponsive && (isMedium || isLarge)
      ? 3
      : 2
    : isMedium || isLarge
      ? 4
      : 3;
  const childrenFlexCn = cn(
    'flex-grow-0 overflow-hidden',
    CN_MAP[divisionCount]
  );

  return (
    <div className={cn('flex flex-wrap gap-4 content-start', className)}>
      {Children.map(children, (child, idx) => (
        <Fragment key={idx}>
          {getAdElement &&
            idx !== 0 &&
            idx % (divisionCount * adLineNumber) === 0 && (
              <div className="w-full">{getAdElement(idx)}</div>
            )}
          <div className={childrenFlexCn}>{child}</div>
        </Fragment>
      ))}
      {showEmptyContentCard && (
        <EmptyContentCardListV4
          childrenCount={children.length}
          divisionCount={divisionCount}
          className={childrenFlexCn}
        />
      )}
    </div>
  );
}

const CN_MAP = {
  2: 'flex-[calc((100%-4px)/2)]',
  3: 'flex-[calc((100%-8px)/3)]',
  4: 'flex-[calc((100%-12px)/4)]',
};
